import React from 'react'
import { css } from 'aphrodite'
import { Row, Col, FormGroup, Input } from 'reactstrap'

import style from '../style'

const CATEGORY_LIST = ['financial', 'technical', 'other']
const PRIORITY_TYPE = ['low', 'mid', 'high']

export const ContactForm = props => (
  <form onSubmit={props.onSubmit}>
    <Row>
      <Col>
        <FormGroup>
          <label className={css(style.form.label)}>Subject *</label>
          <Input
            type='text'
            name={`subject`}
            value={props.editor.subject}
            onChange={props.onChange}
            className={css(style.form.input, style.form.singleRowInput)}
          />
        </FormGroup>
      </Col>
    </Row>
    <Row>
      <Col>
        <Row>
          <Col>
            <FormGroup>
              <Row>
                <Col>
                  <label className={css(style.form.label)}>Category *</label>
                </Col>
              </Row>
              <Row>
                <Col>
                  <select
                    value={props.editor.category}
                    onChange={props.onCategoryChange}
                    className={css(style.selector.select, style.form.select)}
                  >
                    {CATEGORY_LIST.map((item, index) => (
                      <option key={index} value={index}>
                        {item}
                      </option>
                    ))}
                  </select>
                </Col>
              </Row>
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <Row>
                <Col>
                  <label className={css(style.form.label)}>Priority *</label>
                </Col>
              </Row>
              <Row>
                <Col>
                  <select
                    value={props.editor.priority}
                    onChange={props.onPriorityChange}
                    className={css(style.selector.select, style.form.select)}
                  >
                    {PRIORITY_TYPE.map((item, index) => (
                      <option key={index} value={index}>
                        {item}
                      </option>
                    ))}
                  </select>
                </Col>
              </Row>
            </FormGroup>
          </Col>
        </Row>
      </Col>
      <Col>
        <FormGroup>
          <Row>
            <Col>
              <label className={css(style.form.label)}>Community</label>
            </Col>
          </Row>
          <Row>
            <Col>
              <select
                value={props.editor.comId}
                onChange={props.onCommunityChange}
                className={css(style.selector.select, style.form.select)}
              >
                <option value={-1}>none</option>
                {(props.communities || []).map((item, index) => (
                  <option key={index} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
            </Col>
          </Row>
        </FormGroup>
      </Col>
    </Row>
    <Row>
      <Col>
        <FormGroup>
          <label className={css(style.form.label)}>Message *</label>
          <Input
            type='textarea'
            cols='20'
            rows='10'
            name={`content`}
            value={props.editor.content}
            onChange={props.onChange}
            className={css(style.form.input)}
          />
        </FormGroup>
      </Col>
    </Row>
    <Row>
      <Col>
        <input type='submit' value='Send' className={css(style.form.submit)} />
      </Col>
    </Row>
  </form>
)

export default ContactForm



// WEBPACK FOOTER //
// ./src/components/Support/partials/CreateForm.js